export enum MeetingSidebarTabEnum {
  details = "Details",
  topics = "Topics",
  meetings = "Meetings",
  artifacts = "Items",
  askAI = "Ask AI",
  workHistory = "Work history",
  rolesAndReviews = "Career",
  myNotes = "My Notes",
}

export const meetingSidebarAriaLabel = "Meeting Sidebar";
